var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25016 10.2917H5.25V7.10449H7.75033L7.75033 10.2917H9.75016L9.75016 5.41666L6.50016 2.95858L3.25016 5.41666L3.25016 10.2917ZM2.7085 10.8333L2.7085 5.14583L6.50016 2.28149L10.2918 5.14583L10.2918 10.8333H7.20866L7.20866 7.64616H5.79166V10.8333H2.7085Z",
    fill: "#673C8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.86b706f1c5de68071d55dc9a30db2dbf.svg";
export { ForwardRef as ReactComponent };